import { React } from "react";
import { useState, useEffect } from "react";
import Wrapper from "../../components/UI/Wrapper";
import axios from "axios";
import "../../components/LeadPaymentDetails/LeadPaymentDetails.css";
import "react-toastify/dist/ReactToastify.css";
import "../../components/AccountsBillingDetails/AccountsBillingDetails.css";

const LeadBillingDetails = ({ Relocation_Id }) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [billingDetailResponse, setbillingDetailResponse] = useState([]);
  const [showGstFields, setShowGstFields] = useState(false);

  // Fetch rows data from the API
  useEffect(() => {
    getDocument(Relocation_Id);
  }, []);

  async function getDocument(Relocation_Id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetBillingDetailInfo?relocation_id=` +
            Relocation_Id,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setbillingDetailResponse(response.data.data[0]);
          setShowGstFields(!!response.data.data[0]?.gst_number);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  return (
    <>
      <Wrapper className="LeadDetails">
        <div className="viewLeadDetails-form">
          <table
            style={{
              width: "100%",
              color: "#6A6A6A",
              borderRadius: "5px",
            }}
          >
            <tr className="viewLeadDetailsHeading">
              <th
                style={{
                  background: "#5B489D",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <span style={{ fontSize: "18px" }}> Billing Details</span>
              </th>
            </tr>
          </table>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="row">
            <div className="col-3">
              <label className="form-label">Billing Name</label>
              <input
                type="text"
                className="form-control"
                name="billingName"
                value={billingDetailResponse?.billingName || ""}
                disabled
              />
            </div>
            <div className="col-3">
              <label className="form-label">Contact Number</label>
              <input
                type="number"
                className="form-control"
                name="contactNumber"
                value={billingDetailResponse?.contactNumber || ""}
                disabled
              />
            </div>
            <div className="col-6">
              <label className="form-label">Email Id</label>
              <input
                type="text"
                className="form-control"
                name="billingEmail"
                value={billingDetailResponse?.billingEmail || ""}
                disabled
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <label className="form-label">PAN Number</label>
              <input
                type="text"
                className="form-control"
                name="panNumber"
                value={billingDetailResponse?.panNumber || ""}
                disabled
              />
            </div>

            <div className="col-3">
              <label className="form-label">PAN Card</label>
              <span>
                {billingDetailResponse?.panDocName ? (
                  <a
                    style={{
                      color: "#0096EB",
                      textDecoration: "none",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    className="form-control"
                    target="_blank"
                    href={`${baseImageURL}Images/Documents/${billingDetailResponse?.relocation_id}/${billingDetailResponse?.panDocName}`}
                    rel="noopener noreferrer"
                    tabIndex={-1}
                  >
                    PAN Card
                  </a>
                ) : (
                  <div
                    className="form-control"
                    style={{ backgroundColor: "#F0F0F0" }}
                  ></div>
                )}
              </span>
            </div>
          </div>

          <div className="row">
            <div className="col-2">
              <label className="form-label">GST Registered?</label>
            </div>

            <div className="col-3" style={{ display: "flex" }}>
              <input
                type="checkbox"
                checked={showGstFields}
                style={{ marginRight: "6px", marginTop: "-7px" }}
                readOnly
              />
              <label className="form-label">Do you need GST Invoice?</label>
            </div>
          </div>

          {showGstFields && (
            <div className="row">
              <div className="col-3">
                <label className="form-label">Enter GST No.</label>
                <input
                  type="text"
                  className="form-control"
                  name="gst_number"
                  value={billingDetailResponse.gst_number}
                  disabled
                />
              </div>

              <div className="col-6">
                <label className="form-label">Upload GST Copy</label>
                <span>
                  <a
                    style={{
                      color: "#0096EB",
                      textDecoration: "none",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    className="form-control"
                    target="_blank"
                    href={`${baseImageURL}Images/Documents/${billingDetailResponse.relocation_id}/${billingDetailResponse.gstDocName}`}
                    rel="noopener noreferrer"
                    disabled
                  >
                    GST Document
                  </a>
                </span>
              </div>
            </div>
          )}

          <br />
        </div>
      </Wrapper>
      <br />
    </>
  );
};

export default LeadBillingDetails;
